import React, { useState } from "react";
import "./caloriesForm.css";

export default function CaloriesForm(){
	const [submitted, setSubmitted] = useState(false);
	const [age, setAge] = useState(1);
	const [gender, setGender] = useState("male");
	const [height, setHeight] = useState(0);
	const [weight, setWeight] = useState(0);
	const [idealWeight, setIdealWeight] = useState(0);
	const [BMR, setBMR] = useState(0);
	
	const computeIdealWeight=()=> {
		let idlWeight=0;
		let bmr=0;
		let cHeight=parseFloat(height);
		let cWeight=parseFloat(weight);
		let cAge=parseInt(age);
		let inches=cHeight/2.54; 
		
		console.log(cHeight);
		console.log(cWeight);
		console.log(cAge);
		
		if (inches >=60)inches=inches-60;
		else inches=0;
		
		if (gender==="male"){
			idlWeight=(Math.round((50+2.3*inches) * 100) / 100);
			bmr=(10*cWeight) + (6.25*cHeight) - (5*cAge) + 5;
		}else if (gender==="female"){
			idlWeight=(Math.round((45.5+2.3*inches) * 100) / 100);
			bmr=(10*cWeight) + (6.25*cHeight) - (5*cAge) -161;
		}
		console.log(bmr);
		setIdealWeight(idlWeight);
		setBMR(bmr);
	}
  
	const handleSubmit = (e) => {
		e.preventDefault()
		let valid= true;

		if ((isNaN(height))||(isNaN(height) && height.toString().indexOf('.') !== -1)){
			alert("Your Height must be a number");
			valid=false;
		}
		else if ((isNaN(weight))||(isNaN(weight) && weight.toString().indexOf('.') !== -1)){
			alert("Your Weight must be a number");
			valid=false;
		}

		if (valid) setSubmitted(true);

		computeIdealWeight();
	}

	let header1='';
	let header2=''
	if (submitted){
		header1=<h2>1. Your Ideal Weight is Approximately {idealWeight} Kgs.</h2>;
		header2=<h2>2. Your BMR is {BMR} </h2>
	}

    return (
		<div className="App">
			{header1}
			{header2}
			{!submitted && (
				<form onSubmit={handleSubmit} className="simple-form">
					<p><strong>Calculate Your Calories</strong></p>
					<hr/>
					
					Age:
					<input type='number' min="1" max="100" name="age" placeholder="In Years" onChange={e => setAge(e.target.value)} required/>
					<br/><hr/>
					
					Height:
					<input type='text' name="height" placeholder="In Centimeters" onChange={e => setHeight(e.target.value)} required/>
					<br/><hr/>
					
					Weight:
					<input type='text' name="weight" placeholder="In Kilograms" onChange={e => setWeight(e.target.value)} required/>
					<br/><hr/>
					
					Gender:
					<select name="gender" value={gender} onChange={e => setGender(e.target.value)} required>
						<option value="male">Male</option>
						<option value="female">Female</option>
					</select><br/><hr/>

				  <input type="reset" className="reset"/>
				  <input type='submit' className="submit"/>
			  </form>
			)}
		</div>
    );
}